import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ElasticSearchConfigModel } from '@app/core/business/elastic-search/elastic-search-config.model';
import { ModalService } from '@app/core/ui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';


export interface ElasticConfigFieldMeta {
  key: keyof ElasticSearchConfigModel;
  label: string;
  description: string;
}





@Component({
  selector: 'app-elastic-search-config-test',
  templateUrl: './elastic-search-config-test.component.html',
  styleUrls: ['./elastic-search-config-test.component.scss']
})


export class ElasticSearchConfigTestComponent implements OnInit {
  @ViewChild('configForm') configForm!: NgForm;

  public datas: { config: ElasticSearchConfigModel };


  public config: ElasticSearchConfigModel;
  public boostFields: ElasticConfigFieldMeta[] = [
    {
      key: 'boostNameMatch',
      label: 'Correspondance nom (large)',
      description: 'Poids appliqué lorsque le nom du produit contient les mots-clés, même partiellement.',
    },
    {
      key: 'boostNameMatchPrecise',
      label: 'Correspondance nom (précise)',
      description: 'Poids appliqué lorsque le nom du produit correspond précisément aux mots-clés.',
    },
    {
      key: 'boostMatchBrand',
      label: 'Correspondance marque',
      description: 'Poids appliqué quand le mot-clé correspond au nom de la marque.',
    },
    {
      key: 'boostMultiFieldProductType',
      label: 'Type de produit',
      description: 'Poids appliqué aux champs liés au type de produit.',
    },
    {
      key: 'boostMultiFieldIngredient',
      label: 'Ingrédient',
      description: 'Poids appliqué aux champs liés aux ingrédients.',
    },
    {
      key: 'boostMultiFieldNameMatchPrecise',
      label: 'Nom dans multi-champ (précis)',
      description: 'Poids pour une correspondance exacte du nom dans un champ combiné.',
    },
    {
      key: 'boostMultiFieldNBrand',
      label: 'Marque (normale)',
      description: 'Poids appliqué dans un champ combiné pour les marques.',
    },
    {
      key: 'boostMultiFieldEan',
      label: 'Code EAN',
      description: 'Poids appliqué au champ EAN (code-barres).',
    },
    {
      key: 'boostMultiFieldEanSuffixe',
      label: 'Code EAN SUFFIXE',
      description: 'Poids appliqué au champ EAN SUFFIXE (Last 6 characters) (code-barres).',
    },
    {
      key: 'boostMultiFieldProductCode',
      label: 'Code produit',
      description: 'Poids appliqué au code produit dans les recherches.',
    },
    {
      key: 'boostMultiFieldKiwiCode',
      label: 'Code Kiwi',
      description: 'Poids pour un champ spécifique appelé KiwiCode.',
    },
    {
      key: 'boostFavorite',
      label: 'Favoris',
      description: 'Multiplicateur appliqué si le produit est marqué comme favori.',
    },
    {
      key: 'boostDiscount',
      label: 'Promotion',
      description: 'Multiplicateur appliqué si le produit est en promotion.',
    },
    {
      key: 'boostNew',
      label: 'Nouveauté',
      description: 'Multiplicateur appliqué si le produit est une nouveauté.',
    },
  ];


  constructor(
    private injector: Injector,
    private modalService: ModalService,
    public translateService: TranslateService
  ) {
    this.config = this.injector.get('datas')?.config;
  }




  ngOnInit(): void { }

  public close(): void {
    this.modalService.destroy();
  }

  public validate(): void {
    // Vérifie que les champs boost sont tous valides (ngForm gère ça automatiquement)
    if (!this.configForm.valid) {
      alert('Veuillez corriger les champs invalides du formulaire.');
      return;
    }
    // Vérifie les poids des marques propres et exclusives
    const invalidBrand =
      [...this.config.ownBrands, ...this.config.exclusiveBrands].some(
        b => !b.brandName?.trim() || isNaN(Number(b.weight))
      );

    if (invalidBrand) {
      alert('Toutes les marques doivent avoir un nom et un poids numérique.');
      return;
    }

    // Tout est OK, on valide le formulaire
    this.modalService.validate(this.config);
  }

  public addOwnBrand(): void {
    this.config.ownBrands.push({ brandName: '', weight: '' });
  }

  public removeOwnBrand(index: number): void {
    this.config.ownBrands.splice(index, 1);
  }

  public addExclusiveBrand(): void {
    this.config.exclusiveBrands.push({ brandName: '', weight: '' });
  }

  public removeExclusiveBrand(index: number): void {
    this.config.exclusiveBrands.splice(index, 1);
  }
}